import { createAction } from '../../../store.model';
import { PowerBiReport } from '../models/power-bi-report.model';
import { ActionType } from '../power-bi.action';

export interface Reload {
    reportTypeId?: number;
}

export const reload = createAction<ActionType, Reload>(
    ActionType.POWER_BI__RELOAD,
);

export interface ReloadResult extends Reload {
    powerBiReports?: PowerBiReport[];
}

export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.POWER_BI__RELOAD_RESULT,
);
